module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Indice")])]), _c('a', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c002#Copyright"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("C")]), _vm._v("opyright")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c004#BooksByAuthor"
    }
  }, [_vm._v("Libri di Kevin Killiany")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c005#BonusContent"
    }
  }, [_vm._v("CONTENUTO BONUS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_vm._v("Indice")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c007#Dedication"
    }
  }, [_vm._v("Dedica")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c007#TitlePage"
    }
  }, [_vm._v("La vita a terra")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c008#Chapter01"
    }
  }, [_vm._v("Mara: 0330 / 26 Dicembre 2021")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c009#Chapter02"
    }
  }, [_vm._v("Fatima: 0930 / 27 Dicembre 2021")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c010#Chapter03"
    }
  }, [_vm._v("Beth: Lunedi, 27 Dicembre 2021")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c011#Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 28/12/21")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c012#Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1320 / 29 Dicembre 2021")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c013#Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 31 Dicembre")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c014#Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Domenica, 2 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c015#Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 3 Gennaio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c016#Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 04/01/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c017#Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1800 / 8 Gennaio 22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c018#Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 10 Gennaio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c019#Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Lunedi, 10 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c020#Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 11 Gennaio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c021#Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 14/01/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c022#Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1700 / 18 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c023#Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 22/01/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c024#Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Domenica, 23 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c025#Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 26/01/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c026#Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Giovedì, 27 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c027#Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Lunedi, 31 Gennaio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c028#Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 01/02/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c029#Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 3 Febbraio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c030#Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Venerdì, 4 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c031#Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 06/02/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c032#Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1840 / 9 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c033#Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Giovedì, 10 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c034#Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 2100 / 11 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c035#Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 13 Febbraio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c036#Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 15/02/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c037#Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1750 / 17 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c038#Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 18 Febbraio")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c039#Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1810 /21 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c040#Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Martedì, 22 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c041#Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 23/02/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c042#Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Mercoledì, 23 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c043#Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1000 / 24 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c044#Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Venerdì, 25 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c045#Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 27/02/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c046#Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1750 / 28 Febbraio 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c047#Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1920 / 1 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c048#Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Giovedì, 3 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c049#Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 3 Marzo")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c050#Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 2010 / 9 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c051#Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Venerdì, 11 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c052#Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1620 / 14 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c053#Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 15/03/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c054#Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1945 / 17 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c055#Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lije: 19 Marzo")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c056#Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 24/03/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c057#Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1840 / 29 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c058#Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Mercoledì, 30 Marzo 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c059#Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 01/04/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c060#Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Domenica, 3 Aprile 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c061#Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1930 / 5 Aprile 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c062#Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 07/04/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c063#Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mara: 1640 / 7 Aprile 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c064#Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth: Venerdì, 8 Aprile 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c065#Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 04/09/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c066#Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatima: 1847 / 13 Aprile 2022")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c067#Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jael: 16/04/22")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c068#InterviewWithTheAuthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intervista all'autore")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c069#Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ringraziamenti")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c073#AboutTheAuthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L’Autore")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c074#WhatsNext",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Qual è il prossimo?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c070#SpecialSneakPreview1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speciale Anteprima: Alzarsi da terra (Libro 3)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c076#MoreFromEP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Altro dalla Evolved Publishing")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26644936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c006.vue
// module id = 75
// module chunks = 0